import { load } from "@finapi/web-form";
import React, { useCallback, useEffect } from "react";

type Props = {
  id: string;
  targetUrl: string;
  redirectUrl: string;
  errorRedirectUrl: string;
  abortRedirectUrl: string;
};

export const FinApiWebForm = ({
  id,
  targetUrl,
  redirectUrl,
  errorRedirectUrl,
  abortRedirectUrl,
}: Props) => {
  return (
    <FinApiWebFormDevelopment
      id={id}
      targetUrl={targetUrl}
      redirectUrl={redirectUrl}
      errorRedirectUrl={errorRedirectUrl}
      abortRedirectUrl={abortRedirectUrl}
    />
  );
  // if (process.env.NODE_ENV === "development") {
  //   return (
  //     <FinApiWebFormDevelopment
  //       id={id}
  //       targetUrl={targetUrl}
  //       invoiceIds={invoiceIds}
  //     />
  //   );
  // }

  // return (
  //   <FinApiWebFormProduction
  //     id={id}
  //     targetUrl={targetUrl}
  //     invoiceIds={invoiceIds}
  //   />
  // );
};

export const FinApiWebFormProduction = ({ id, targetUrl }: Props) => {
  const createWebForm = useCallback(
    async (target: HTMLElement) => {
      load(
        target,
        {
          token: id,
          targetUrl,
          layoutConfig: "xs",
          backToAppUrl: "https://customer.app",
          customerSupportUrl: "https://finapi.io",
          language: "de",
          targetEnvironment: "sandbox",
        },
        {
          onLoaded: () => {
            // handle "onLoaded" event
          },
          onComplete: () => {
            // handle "onComplete" event
          },
          onFail: () => {
            // handle "onFail" event
          },
          onAbort: () => {
            // handle "onAbort" event
          },
          onLoadError: () => {
            // handle "onLoadError" event
          },
        },
      );
    },
    [id, targetUrl],
  );

  const containerRef = (container: HTMLDivElement) => {
    if (container) {
      createWebForm(container);
    }
  };

  return <div ref={containerRef} />;
};

const FinApiWebFormDevelopment = ({
  id,
  targetUrl,
  redirectUrl,
  errorRedirectUrl,
  abortRedirectUrl,
}: Props) => {
  useEffect(() => {
    window.location.href = `${targetUrl}/wf/${id}?redirectUrl=${redirectUrl}&errorRedirectUrl=${errorRedirectUrl}&abortRedirectUrl=${abortRedirectUrl}`;
  }, [targetUrl, id, redirectUrl, errorRedirectUrl, abortRedirectUrl]);

  return null;
};
